export default __webpack_public_path__ + "static/media/home-icon-active.dd447364.webp";